"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidDate = exports.formatDayUS = exports.getFormattedTimezone = exports.getMonthName = exports.getMonthFullName = exports.getWeekdayName = exports.getYear = exports.getDayInMonth = exports.generateHours = exports.generateEndTimeValues = exports.generateStartTimeValues = exports.changeTimezone = exports.isShorterThanDuration = exports.getDateTime = exports.getDate = exports.getTime = exports.isSameTime = exports.isToday = exports.hasTimePassed = exports.hasTimePassedForToday = exports.sortByDate = exports.formatTimezone = exports.getTimezoneName = exports.getTimezone = exports.formatDateTime = exports.getTimezoneOffsetById = exports.formatMinutesToHoursAndMinutes = exports.formatQuarter = exports.formatMonthYear = exports.stringifyYearMonth = exports.stringifyDate = exports.formatDate = exports.formatMetricOpen = exports.formatTimeToHoursMinutes = exports.formatDateToDate = exports.formatStartToEndDate = void 0;
var tslib_1 = require("tslib");
var moment_1 = tslib_1.__importDefault(require("moment"));
require("moment-timezone");
var first_1 = tslib_1.__importDefault(require("lodash/first"));
var last_1 = tslib_1.__importDefault(require("lodash/last"));
var defaultDateFormat = 'MMM DD, YYYY';
function formatStartToEndDate(_a) {
    var start = _a.start, end = _a.end, _b = _a.format, format = _b === void 0 ? defaultDateFormat : _b;
    var endDate = 'N/A';
    var startDate = (0, moment_1.default)(start).format(format);
    if (end)
        endDate = (0, moment_1.default)(end).format(format);
    return startDate + ' / ' + endDate;
}
exports.formatStartToEndDate = formatStartToEndDate;
function formatDateToDate(startDate, endDate, format) {
    if (format === void 0) { format = defaultDateFormat; }
    if (!startDate && !endDate)
        return 'N/A';
    var start = (0, moment_1.default)(startDate).format(format);
    var seperator = startDate ? ' - ' : null;
    var end = endDate ? (0, moment_1.default)(endDate).format(format) : 'Now';
    return start + seperator + end;
}
exports.formatDateToDate = formatDateToDate;
function formatTimeToHoursMinutes(time) {
    return Math.floor(time.asHours()) + ':' + (time.minutes() < 10 ? '0' + time.minutes() : time.minutes());
}
exports.formatTimeToHoursMinutes = formatTimeToHoursMinutes;
function formatMetricOpen(_a) {
    var firstSubmit = _a.firstSubmit, lastSubmit = _a.lastSubmit, metricAverage = _a.metricAverage;
    var projectOfficeTime = (0, moment_1.default)().startOf('day').add(9, 'hours');
    var minutesPassed = (0, moment_1.default)().diff(projectOfficeTime, 'minutes');
    if (minutesPassed > 8 * 60)
        minutesPassed = 8 * 60;
    if (minutesPassed === 0)
        minutesPassed = 1;
    var firstDelivery = moment_1.default.duration(firstSubmit, 'seconds');
    var lastDelivery = moment_1.default.duration((0, moment_1.default)().diff((0, moment_1.default)(lastSubmit)));
    var result = {};
    result.firstDelivery = firstSubmit ? formatTimeToHoursMinutes(firstDelivery) : '-';
    result.lastDelivery = lastSubmit ? formatTimeToHoursMinutes(lastDelivery) : '-';
    result.average = Math.floor(((metricAverage * 100) / minutesPassed) * 60) / 100;
    return result;
}
exports.formatMetricOpen = formatMetricOpen;
function formatDate(date, format, noDateString) {
    if (format === void 0) { format = defaultDateFormat; }
    if (noDateString === void 0) { noDateString = '-'; }
    if (!date)
        return noDateString;
    return (0, moment_1.default)(date).format(format);
}
exports.formatDate = formatDate;
function stringifyDate(date) {
    if (!date)
        return null;
    return (0, moment_1.default)(date).format('YYYY-MM-DD');
}
exports.stringifyDate = stringifyDate;
function stringifyYearMonth(date) {
    if (!date)
        return null;
    return (0, moment_1.default)(date).format('YYYY-MM');
}
exports.stringifyYearMonth = stringifyYearMonth;
function formatMonthYear(date) {
    if (date === void 0) { date = new Date(); }
    if (!date)
        return '-';
    return (0, moment_1.default)(date).format('MMM YYYY');
}
exports.formatMonthYear = formatMonthYear;
function formatQuarter(date) {
    if (date === void 0) { date = new Date(); }
    return (0, moment_1.default)(date).quarter();
}
exports.formatQuarter = formatQuarter;
function formatMinutesToHoursAndMinutes(mins) {
    /** @type {any} */
    var hours = Math.floor(mins / 60);
    /** @type {any} */
    var minutes = mins % 60;
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var duration = hours + ':' + minutes;
    return duration;
}
exports.formatMinutesToHoursAndMinutes = formatMinutesToHoursAndMinutes;
function getTimezoneOffsetById(_a) {
    var id = _a.id, staticData = _a.staticData, hideIsoCode = _a.hideIsoCode;
    var tz = staticData.getFullDataFromArray(id, 'timezones');
    var timezone = moment_1.default.tz(tz.name);
    var timezoneOffsetInMinutes = timezone.utcOffset();
    var prefix = timezoneOffsetInMinutes > 0 ? '+' : '';
    var hours = Math.floor(timezoneOffsetInMinutes / 60);
    var minutes = (0, moment_1.default)(timezoneOffsetInMinutes % 60).format('mm');
    var minutesString = Number(minutes) !== 0 ? ':' + minutes : '';
    var tzName = tz.name.replace(/_/g, ' ');
    var tzOffset = "".concat(prefix).concat(hours).concat(minutesString);
    var tzIsoCode2 = hideIsoCode ? '' : tz.isoCode2;
    return tzIsoCode2 + ' ' + tzOffset + ' ' + tzName;
}
exports.getTimezoneOffsetById = getTimezoneOffsetById;
function formatDateTime(date, showTimezone) {
    if (showTimezone === void 0) { showTimezone = true; }
    var m = moment_1.default.tz(date, getTimezone());
    var formattedDate = m.format(defaultDateFormat);
    var formattedTime = m.format('HH:mm');
    if (showTimezone) {
        var formattedTimezone = formatTimezone(m);
        var format = "".concat(formattedDate, " at ").concat(formattedTime, " ").concat(formattedTimezone);
        return format;
    }
    else {
        return "".concat(formattedDate, " at ").concat(formattedTime);
    }
}
exports.formatDateTime = formatDateTime;
function getTimezone() {
    return moment_1.default.tz.guess();
}
exports.getTimezone = getTimezone;
function getTimezoneName() {
    return moment_1.default.tz().zoneName();
}
exports.getTimezoneName = getTimezoneName;
function formatTimezone(momentDate) {
    var timezoneIdentifier = momentDate.format('z');
    var timezoneOffsetInMinutes = momentDate.utcOffset();
    var prefix = timezoneOffsetInMinutes >= 0 ? '+' : '';
    var hours = Math.floor(timezoneOffsetInMinutes / 60);
    var minutes = timezoneOffsetInMinutes % 60;
    var minutesString = minutes !== 0 ? ':' + minutes : '';
    return "".concat(timezoneIdentifier).concat(prefix).concat(hours).concat(minutesString);
}
exports.formatTimezone = formatTimezone;
/**
 * Scheduling Helpers
 * ==================
 *
 * @TODO export to a separate file eventually
 */
function sortByDate(sortableArray, opts) {
    if (opts === void 0) { opts = {}; }
    var prop = opts.prop || 'date';
    var sortFn = opts.descending
        ? function (i1, i2) { return new Date(i2[prop]).getTime() - new Date(i1[prop]).getTime(); }
        : function (i1, i2) { return new Date(i1[prop]).getTime() - new Date(i2[prop]).getTime(); };
    return sortableArray.slice().sort(sortFn);
}
exports.sortByDate = sortByDate;
// TODO - check where groupAdjacentAvailabilities is used as Module './availability' has already exported a member named 'groupAdjacentAvailabilities'. Consider explicitly re-exporting to resolve the ambiguity
// export function groupAdjacentAvailabilities (sortedAvailabilities) {
//   const availabilities = mergeClientAndExpertAvailabilities(
//     sortedAvailabilities
//   )
//   return availabilities.reduce((groupedSlots, slot, index) => {
//     const newGroupId = slot.startTime
//     if (index === 0) {
//       groupedSlots[newGroupId] = [slot]
//       return groupedSlots
//     }
//     const previousSlot = sortedAvailabilities[index - 1]
//     if (isSlotAdjacentAndOfSameType(previousSlot, slot)) {
//       const lastGroupId = last(Object.keys(groupedSlots))
//       groupedSlots[lastGroupId].push(slot)
//     } else {
//       groupedSlots[newGroupId] = [slot]
//     }
//     return groupedSlots
//   }, {})
// }
/**
 * Will take a list of availabilities and return a new list where
 * if 2 availabilities with the same start and end dates will be merged into 1 slot.
 *
 * E.g. Client Availability 08:00 - 08:30, and
 *      Expert Availability 08:00 - 08:30
 *
 *      will be merged to:
 *      "Both" Availability 08:00 - 08:30
 * @param {*} sortedAvailabilities
 */
function mergeClientAndExpertAvailabilities(sortedAvailabilities) {
    return sortedAvailabilities.reduce(function (resultingSlots, slot, index) {
        if (index === 0) {
            return [slot];
        }
        var previousSlot = sortedAvailabilities[index - 1];
        var isSameTimeAndDifferentType = isSameTime(slot.startTime, previousSlot.startTime) && slot.type !== previousSlot.type;
        var isSameTimeAndSameType = isSameTime(slot.startTime, previousSlot.startTime) && slot.type === previousSlot.type;
        if (isSameTimeAndDifferentType) {
            resultingSlots[index - 1] = tslib_1.__assign(tslib_1.__assign({}, previousSlot), { type: 'BOTH' });
        }
        else if (isSameTimeAndSameType) {
            /* Do nothing, we don't need duplicates */
        }
        else {
            resultingSlots.push(slot);
        }
        return resultingSlots;
    }, {});
}
function isSlotAdjacentAndOfSameType(previousSlot, currentSlot) {
    // We don't care about slots of different types
    if (previousSlot.type !== currentSlot.type)
        return false;
    if (isSameTime(currentSlot.startTime, previousSlot.endTime))
        return true;
    // slots are sorted by start time, no need don't check it here,
    // we just have to make sure start time is earlier than end time of our previous slot
    if (currentSlot.startTime < previousSlot.endTime)
        return true;
    return false;
}
function hasTimePassedForToday(date, timeString, timezone) {
    if (!timeString)
        return false;
    if (!isToday(date))
        return false;
    var currentTimeString = getTime(new Date(), timezone);
    if (currentTimeString === timeString)
        return false;
    return hasTimePassed(currentTimeString, timeString);
}
exports.hasTimePassedForToday = hasTimePassedForToday;
function hasTimePassed(startTimeString, endTimeString) {
    var startTime = extractTimeValues(startTimeString);
    var endTime = extractTimeValues(endTimeString);
    if (startTime.hours < endTime.hours)
        return false;
    if (startTime.minutes < endTime.minutes)
        return false;
    return true;
}
exports.hasTimePassed = hasTimePassed;
function isToday(date, timezone) {
    var tz = timezone || getTimezone();
    return moment_1.default.tz(date, tz).isSame((0, moment_1.default)(), 'day');
}
exports.isToday = isToday;
/**
 * Checks wether the times are the same (1 second error tolerance)
 *
 * @param {Date} date1
 * @param {Date} date2
 */
function isSameTime(date1, date2) {
    return (0, moment_1.default)(date1).isSame(date2, 'second');
}
exports.isSameTime = isSameTime;
function getTime(date, tz) {
    if (date === void 0) { date = new Date(); }
    var timezone = tz || getTimezone();
    return moment_1.default.tz(date, timezone).format('HH:mm');
}
exports.getTime = getTime;
function getDate(date, tz) {
    var timezone = tz || getTimezone();
    return moment_1.default.tz(date, timezone).toDate();
}
exports.getDate = getDate;
function extractTimeValues(timeString) {
    var hours = parseInt(timeString.slice(0, 2), 10);
    var minutes = parseInt(timeString.slice(-2), 10);
    return { hours: hours, minutes: minutes };
}
function getDateTime(date, time, tz) {
    var _a = extractTimeValues(time), hours = _a.hours, minutes = _a.minutes;
    var timezone = tz || getTimezone();
    var day = date.getDate();
    var month = date.getMonth();
    var year = date.getFullYear();
    return (0, moment_1.default)()
        .tz(timezone)
        .set({
        date: day,
        month: month,
        year: year,
        hour: hours,
        minute: minutes,
        second: 0,
        millisecond: 0,
    })
        .toDate();
}
exports.getDateTime = getDateTime;
function isShorterThanDuration(duration, availabilities) {
    var firstAvailability = (0, first_1.default)(availabilities);
    var lastAvailability = (0, last_1.default)(availabilities);
    var diff = (0, moment_1.default)(lastAvailability.endTime).diff(firstAvailability.startTime, 'minutes');
    return diff < duration;
}
exports.isShorterThanDuration = isShorterThanDuration;
/**
 * Takes the exact time, but changes the timezone/offset for the date.
 * E.g. 2017-01-01 10:00:00 (Europe/Berlin) + America/Toronto timezone => 2017-01-01 16:00:00
 *
 * @param {Date|string} date date to convert
 * @param {String} timezone  timezone to switch to
 */
function changeTimezone(date, timezone) {
    var dateString = (0, moment_1.default)(date).format('YYYY-MM-DD HH:mm');
    return moment_1.default.tz(dateString, timezone);
}
exports.changeTimezone = changeTimezone;
// Used for availability calendar and related inputs
function generateStartTimeValues(date, timezone) {
    if (!date)
        return [];
    if (!isToday(date, timezone)) {
        return generateHours();
    }
    var time = isToday(date, timezone) ? getTime(new Date(), timezone) : null;
    var mins = time.slice(3, 5);
    var minIncrement = Math.ceil(Number(mins) / 15) * 15;
    var roundedTime = roundToFullHour(time);
    var incrementedTime = incrementByMins(roundedTime, minIncrement);
    return generateHours(incrementedTime);
}
exports.generateStartTimeValues = generateStartTimeValues;
function generateEndTimeValues(date, startTime, minDuration) {
    if (minDuration === void 0) { minDuration = 30; }
    if (!date)
        return [];
    if (!startTime)
        return [];
    var incrementedTime = incrementByMins(startTime, minDuration);
    return generateHours(incrementedTime).concat(['24:00']);
}
exports.generateEndTimeValues = generateEndTimeValues;
function generateHours(startTime) {
    var hours = [];
    var currTime = startTime || '00:00';
    while (!isPastMidnight(currTime)) {
        hours.push(currTime);
        currTime = incrementByMins(currTime, 15);
    }
    return hours;
}
exports.generateHours = generateHours;
function incrementByMins(timeString, incrementInMinutes) {
    var incrementByHours = Math.floor(incrementInMinutes / 60);
    var incrementByMinutes = incrementInMinutes % 60;
    var _a = extractTimeValues(timeString), hours = _a.hours, minutes = _a.minutes;
    var newMinutes = (incrementByMinutes + minutes) % 60;
    var newHours = incrementByHours + hours + Math.floor((incrementByMinutes + minutes) / 60);
    return formatTimeForDisplay(newHours, newMinutes);
}
function roundToFullHour(time) {
    return time ? "".concat(time.slice(0, 2), ":00") : time;
}
function formatTimeForDisplay(hours, minutes) {
    return "".concat(('00' + hours).slice(-2), ":").concat(('00' + minutes).slice(-2));
}
function isPastMidnight(timeString) {
    var hours = extractTimeValues(timeString).hours;
    if (hours >= 24)
        return true;
    return false;
}
function getDayInMonth(date, tz) {
    var timezone = tz || getTimezone();
    return moment_1.default.tz(date, timezone).format('DD');
}
exports.getDayInMonth = getDayInMonth;
function getYear(date, tz) {
    var timezone = tz || getTimezone();
    return moment_1.default.tz(date, timezone).format('YYYY');
}
exports.getYear = getYear;
function getWeekdayName(date, tz) {
    var timezone = tz || getTimezone();
    return moment_1.default.tz(date, timezone).format('dddd');
}
exports.getWeekdayName = getWeekdayName;
function getMonthFullName(date, tz) {
    var timezone = tz || getTimezone();
    return moment_1.default.tz(date, timezone).format('MMMM');
}
exports.getMonthFullName = getMonthFullName;
function getMonthName(date, tz) {
    var timezone = tz || getTimezone();
    return moment_1.default.tz(date, timezone).format('MMM');
}
exports.getMonthName = getMonthName;
function getFormattedTimezone(tz) {
    var timezone = tz || getTimezone();
    var m = moment_1.default.tz(timezone);
    var formattedTimezoneName = timezone ? timezone.replace(/_/g, ' ') : '';
    return "".concat(formatTimezone(m), " ").concat(formattedTimezoneName);
}
exports.getFormattedTimezone = getFormattedTimezone;
/**
 * Format day in US specific way
 * @param {Date} date
 * @returns {string} in format Mon DD, YYYY or `-` when empty
 */
function formatDayUS(date) {
    var invalid = isNaN(Date.parse(date));
    if (!date || invalid) {
        return '-';
    }
    var ts = new Date(date);
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    }).format(ts);
}
exports.formatDayUS = formatDayUS;
function isValidDate(input) {
    try {
        var d = new Date(input);
        return d instanceof Date && !isNaN(d);
    }
    catch (error) {
        return false;
    }
}
exports.isValidDate = isValidDate;
